import React from 'react'
import { Grid, Segment } from 'semantic-ui-react'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { withConstantPermissions } from 'shared'
//@ts-ignore
import { SegmentGroup, FlexTableChild, TableContainer, GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { downloadRemote } from '../../FileDetails'
import { translateLKMessage, translateWebMessages } from '../translator'
import { constants as DCConstants, actions as DCActions } from '../../DetailsContainer'
import FileUpload, { open as openFileUpload } from '../../shared/FileUpload'
import { openFileDetails } from '../../FileDetails'
import { deleteFile, toggleFileVisa, toggleDeleteFileVisa } from 'src/store/linkedFiles'
import { translate } from 'loankeeper-common/helpers'
import { actions as LKModalActions } from '../../shared/LKModal'

import { FilesProps } from '../types.LoanDetails'

const LKGridConfig = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_files',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: true,

  enableRowSelection: true,

  getRowStyle: ({
    node: {
      data: { FActive },
    },
  }) => {
    if (FActive !== 1) {
      return { backgroundColor: 'gray' }
    }
  },

  columnConfigs: {
    FActive: {
      iconComponent: (value: number) => (value === 1 ? 'ok' : null),
    },

    ID: {
      cellStyle: { textAlign: 'right' },
    },
  },
}

@withRouter
//@ts-ignore
@connect(undefined, {
  openError: (message: string) => LKModalActions.openError(message),
  openFileUpload: (args: any) => openFileUpload(args),
  fetchPage: (ID: string, hash: string) =>
    DCActions.fetchPage({
      type: 'Loan',
      ID,
      hash,
      page: 'linkedfiles',
    }),

  openFileDetails: (ID, hash, type) => openFileDetails({ ID, hash, type }),
  downloadRemote,
  deleteFile,
  toggleFileVisa,
  toggleDeleteFileVisa,
})
//@ts-ignore
@withConstantPermissions(['LFL_ADD as CanAdd', 'LFL_VIEW as CanView', 'LFL_VISA as CanChangeVisa'])
class Files extends React.Component<FilesProps> {
  getContextMenuItems = (props: { node: any }) => [
    ...(['jpg', 'pdf'].includes(props.node.data.Ext.toLowerCase())
      ? [
          {
            name: translateWebMessages('cmd_preview_linkedfile'),
            action: () => this.viewFile(props),
            icon: 'preview',
            permissionKey: 'LFL_VIEW',
          },
        ]
      : []),

    {
      name: translateWebMessages('cmd_lfl_download'),
      action: () => {
        const { ID, HashSum_FileID_: hash, Ext } = props.node.data

        this.props.downloadRemote({ ID, hash, extension: Ext })
      },
      icon: 'download',
      permissionKey: 'LFL_VIEW',
    },

    {
      name: translate('fr_LFL_pick-cmd_edit_linkedfile'),
      action: () => {
        const { ID, HashSum_FileID_, FActive, Title, Title_ALT, TypeID } = props.node.data
        const { ClientID, HashSum_ClientID_ } = this.props.data.base

        this.props.openFileUpload({
          ClientID,
          HashSum_ClientID_,
          ID,
          HashSum_FileID_,
          FActive,
          Title,
          Title_ALT,
          TypeID,
        })
      },
      icon: 'edit',
      permissionKey: 'LFL_EDIT',
    },

    {
      name: translate('fr_LFL_pick-cmd_delete_linkedfile'),
      action: () => {
        const { ID, HashSum_FileID_ } = props.node.data
        const { ClientID, HashSum_ClientID_ } = this.props.data.base

        return this.props
          .deleteFile({
            ID,
            HashSum_FileID_,
            ClientID,
            HashSum_ClientID_,
          })
          .then(() => {
            this.handleFileUploadSuccess()
          })
      },
      confirmModalConfig: { message: translateLKMessage('MSG_ARE_YOU_SURE') },
      icon: 'delete',
      permissionKey: 'LFL_DELETE',
    },

    {
      name:
        props.node.data.VisaLoginFull === null && props.node.data.VisaSEC_UserID === 0
          ? translate('frm_collateral_view-cmd_collateral_visa')
          : translate('frm_collateral_view-cmd_delete_collateral_visa'),
      action: () => {
        const { ID, HashSum_FileID_ } = props.node.data
        let isVisa = true

        if (props.node.data.VisaLoginFull === null && props.node.data.VisaSEC_UserID === 0) {
          isVisa = false
          this.handleToggleFileVisaAction(isVisa, ID, HashSum_FileID_)
        } else {
          this.handleToggleFileVisaAction(isVisa, ID, HashSum_FileID_)
        }
      },
      icon: `${
        props.node.data.VisaLoginFull === null && props.node.data.VisaSEC_UserID === 0
          ? 'bullet_green'
          : 'bullet_green_delete'
      }`,
      permissionKey: 'LFL_VISA',
    },
  ]

  viewFile = ({
    node: {
      data: { ID, HashSum_FileID_: hash, Ext },
    },
  }) => {
    this.props.openFileDetails(ID, hash, Ext)
  }

  handleOpenFileUpload = () => {
    const {
      openFileUpload: open,
      ID,
      hash,
      data: {
        base: { ClientID, HashSum_ClientID_ },
      },
    } = this.props

    //@ts-ignore
    open({ LoanID: ID, HashSum_LoanID_: hash, ClientID, HashSum_ClientID_ })
  }

  handleFileUploadSuccess = () => {
    this.props.fetchPage(this.props.ID, this.props.hash)
  }

  handleRowDoubleClicked = (props: {node: {data: {ID: number, HashSum_FileID_ :string, Ext: string}}}) => {
    if (this.props.CanView && ['jpg', 'pdf'].includes(props.node.data.Ext.toLowerCase())) {
      this.viewFile(props)
    }
  }

  handleToggleFileVisaAction = (isVisa: boolean, ID: number, HashSum_FileID_: string) => {
    const { ClientID, HashSum_ClientID_ } = this.props.data.base
    if (!isVisa) {
      this.props
        .toggleFileVisa({
          ID,
          HashSum_FileID_,
          ClientID: ClientID,
          HashSum_ClientID_: HashSum_ClientID_,
        })
        .then((result) => {
          if (toggleFileVisa.rejected.match(result)) {
            //@ts-ignore
            this.props.openError(result.payload)
          } else {
            this.handleFileUploadSuccess()
          }
        })
    } else {
      this.props
        .toggleDeleteFileVisa({
          ID,
          HashSum_FileID_,
          ClientID: ClientID,
          HashSum_ClientID_: HashSum_ClientID_,
        })
        .then((result) => {
          if (toggleDeleteFileVisa.rejected.match(result)) {
            //@ts-ignore
            this.props.openError(result.payload)
          } else {
            this.handleFileUploadSuccess()
          }
        })
    }
  }

  render() {
    const {
      ID,
      data: { linkedfiles },
    } = this.props

    return (
      <SegmentGroup>
        <FileUpload onSuccess={this.handleFileUploadSuccess} />

        <Segment.Group>
          <FlexTableChild>
            <TableContainer>
              <LKGrid
                instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-Files`}
                rowData={linkedfiles}
                {...LKGridConfig}
                onRowDoubleClicked={this.handleRowDoubleClicked}
                getContextMenuItems={this.getContextMenuItems}
              />
            </TableContainer>
          </FlexTableChild>

          {this.props.CanAdd && (
            <Segment>
              <GridContainer>
                <Grid>
                  <Grid.Row columns={1}>
                    <Grid.Column textAlign="right">
                      <LKButton alias="add" onClick={this.handleOpenFileUpload}>
                        {translate('frm_loan_view-cmd_add_linkedfile')}
                      </LKButton>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </GridContainer>
            </Segment>
          )}
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

export default Files
